import { render } from "./AgeGate.vue?vue&type=template&id=37beeb87"
import script from "./AgeGate.vue?vue&type=script&lang=js"
export * from "./AgeGate.vue?vue&type=script&lang=js"

import "./AgeGate.vue?vue&type=style&index=0&id=37beeb87&lang=scss"
script.render = render

export default script